/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { SpeakersEnum } from 'models/viewModels';

export interface VehicleAudioActivityLevel {
  vehicleNumber: string;
  lastTimestamp: Date;
}

export type AudioFilterParams = {
  roles: SpeakersEnum[];
  teams: string[];
  searchQueries: string[];
  categories: string[];
};

export type SpeakersType = keyof typeof SpeakersEnum;

export const SpeakersLabels: Record<SpeakersEnum, SpeakersType> = {
  [SpeakersEnum.Driver]: 'Driver',
  [SpeakersEnum.Crew_Chief]: 'Crew_Chief',
  [SpeakersEnum.Spotter]: 'Spotter',
  [SpeakersEnum.Unidentified]: 'Unidentified',
};

// TODO: Replace this with categories we retrieve from ds api (make sure to leave the none concat though) in story #62816
// 'none' is a hardcoded value that queries for messages that lack any category tags - must match with the value used in AudioCoroutineRepository.kt
export const NoneCategory = 'none';
export const CategoryDictionary = [
  'performance',
  'track_location',
  'track_condition',
  'high_priority_strategy',
  'strategy',
].concat([NoneCategory]);

export const defaultCategoryToIsFiltered = CategoryDictionary.reduce((accumulator, category) => {
  accumulator[category] = true;
  return accumulator;
}, {} as Record<string, boolean>);

export const defaultAudioFilters: AudioFilterParams = {
  roles: Object.keys(SpeakersLabels).map((key) => parseInt(key) as SpeakersEnum),
  teams: [],
  searchQueries: [],
  categories: CategoryDictionary,
};
